var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSocialComment = function SvgSocialComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505C69",
    d: "M13.58 4.65h-3.16c-3.158 0-5.753 2.595-5.753 5.754 0 3.046 2.369 5.415 5.528 5.528v2.82c0 .114 0 .226.113.34.113.112.225.225.451.225.113 0 .226 0 .338-.113.226-.113 4.852-3.046 5.98-4.062 1.467-1.24 2.256-2.933 2.256-4.738 0-3.159-2.594-5.754-5.753-5.754m2.82 9.59c-.79.677-3.61 2.482-5.077 3.497v-2.369c0-.338-.226-.564-.564-.564h-.338c-2.708 0-4.626-1.805-4.626-4.4 0-2.595 2.03-4.626 4.626-4.626h3.046c2.707 0 4.738 2.031 4.738 4.626 0 1.467-.677 2.933-1.805 3.836"
  })));
};
export default SvgSocialComment;